module.exports = __webpack_public_path__ + "static/joc_11-3c120bbb15e65490b5fe7811c347e819.jpg";